import DropdownList from './DropdownList';
import DropdownSelect from './DropdownSelect';

/**
 * @fileOverview A manager class for all dropdown types
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires /src/js/01-atoms/DropdownList.js
 * @requires /src/js/01-atoms/DropdownSelect.js
 * @requires Polyfill:NodeList.forEach
 */


/**
 * Initialize all dropdowns in the page with default options
 * @exports
 */
export default function initAllDropdowns( dropdownsOptions = [], defaultOptions = null ) {
  const
    manager = new dropdownManager(),
    targets = document.querySelectorAll( '.dropdown' );

  targets.forEach(( target, idx ) => {
    const dropdownOptions = ( function evalOptions() {
      let retval = {};
      if ( dropdownsOptions[ idx ]) {
        retval = dropdownsOptions[ idx ];
      } else if ( null !== defaultOptions && typeof defaultOptions === 'object' ) {
        retval = defaultOptions;
      }
      return retval;
    }());
    manager.createDropdown( target, dropdownOptions );
  });

  return manager;
}

/**
  * A factory/manager for dropdown objects.
  * @exports
  */
export class dropdownManager {
  /**
   * Create a dropdownManager
   */
  constructor() {

    this.dropdowns = [];
    this.activeDropdown = null;

    // -- All dropdowns delegate some events to the document body,
    //    the manager takes care of these.
    //    We use some custom events so we can pass the triggered dropdown
    //    object index to the manager class via the 'detail' property.


    // -- Hide the active dropdown if we click anywhere in the page not
    //    inside the dropdown list.
    document.body.addEventListener( 'mousedown', e => {

      if ( this.activeDropdown ) {

        if ( this.activeDropdown.baseEl.contains( e.target )) {

          // Bail out if target is a list element
          if ( e.target !== this.activeDropdown.trigger ) {
            return;
          }

          // Filter this event
          e.stopPropagation();
          e.preventDefault();

        }

        this.activeDropdown.hideList();
        this.activeDropdown = null;

      }

    }, true );


    document.body.addEventListener( 'btn_focus', e => {

      const triggered = this.dropdowns[ e.detail ];

      if ( this.activeDropdown ) {
        this.activeDropdown.hideList();
        this.activeDropdown = null;
      }

      if ( triggered.list.isActive ) {

        if ( e.target !== triggered.list.el ) {

          const
            focusElement =
              triggered.list.el.children[ 0 ].hasAttribute( 'disabled' ) ?
                triggered.list.el.children[ 1 ] :
                triggered.list.el.children[ 0 ];

          focusElement.focus();

          triggered.showList();
          this.activeDropdown = triggered;

        } else {
          triggered.hideList();
          this.activeDropdown = null;
        }

      }

    });


    document.body.addEventListener( 'btn_click', e => {

      const triggered = this.dropdowns[ e.detail ];

      if ( this.activeDropdown &&
          this.activeDropdown !== triggered ) {
        this.activeDropdown.hideList();
        this.activeDropdown = null;
      }

      this.activeDropdown = triggered.toggleList() ? triggered : null;

    });

  }


  /**
   * Initialize a dropdown
   * @param { object } element
   */
  createDropdown( element, options ) {

    let dropdown = null;
    const dropdownIndex = this.dropdowns.length;

    switch ( element.nodeName ) {
    case 'NAV':
    case 'DIV':
      dropdown = new DropdownList( element, options, dropdownIndex, this );
      break;
    case 'SELECT':
      dropdown = new DropdownSelect( element, options, dropdownIndex, this );
      break;
    default:
      break;
    }

    // -- We save our object references here ^^
    if ( dropdown ) {
      this.dropdowns.push( dropdown );
    }

  }

  find( element ) {
    const dataIndex = element.dataset.index;
    if ( dataIndex ) {
      return this.dropdowns[ parseInt( dataIndex ) ];
    } else {
      return null;
    }
  }

}
